import { Dialog } from '@base-ui-components/react/dialog';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { getHtmlCopy } from '../../i18n';

import './Modal.scss';

export interface ModalSlots {
    body?: {
        classes?: string;
    };
    root?: {
        classes?: string;
    };
}

export interface ModalProps {
    children: ReactNode;
    classes?: string;
    heading?: string;
    isDismissable?: boolean;
    id?: string;
    onClose?: () => void;
    open: boolean;
    slots?: ModalSlots;
}

export const Modal = ({
    children,
    heading,
    id,
    onClose,
    open,
    slots,
    isDismissable = true,
}: ModalProps) => {
    const isKindle = window.OverDrive?.isKindle;

    const onOpenChange = (isOpen: boolean) => {
        if (!isOpen && isDismissable) {
            onClose?.();
        }
    };

    return (
        <Dialog.Root
            onOpenChange={onOpenChange}
            open={open}
            dismissible={isDismissable}
        >
            <Dialog.Portal>
                <Dialog.Backdrop className="backdrop" />
                <Dialog.Popup
                    className={clsx(
                        'modal__root',
                        isKindle && 'modal__root--kindle'
                    )}
                >
                    <div className="modal__scroll-container">
                        <div
                            className={clsx(
                                'modal__main',
                                slots?.root?.classes
                            )}
                        >
                            <div className="modal__header">
                                <Dialog.Title
                                    className="modal__heading"
                                    id={id ? `${id}-title` : ''}
                                >
                                    {heading}
                                </Dialog.Title>

                                {isDismissable && (
                                    <Dialog.Close
                                        aria-label={getHtmlCopy('close')}
                                        className="modal__x-button"
                                    >
                                        &#215;
                                    </Dialog.Close>
                                )}
                            </div>

                            <div
                                className={clsx(
                                    'modal__body',
                                    slots?.body?.classes
                                )}
                            >
                                {children}
                            </div>
                        </div>
                    </div>
                </Dialog.Popup>
            </Dialog.Portal>
        </Dialog.Root>
    );
};
